import * as prismic from "@prismicio/client";

const endpoint = prismic.getRepositoryEndpoint("illinois-squeeze-upside");
const accessToken =
  "MC5haG52N3hFQUFDZ0FtUDlX.77-9Au-_ve-_ve-_ve-_ve-_ve-_vVLvv71BTkXvv708W1Lvv73vv73vv71vAe-_vX7vv73vv73vv73vv71u77-9S--_vQ"; // Set an access token
const routes = [];

const client = prismic.createClient(endpoint, { routes, accessToken });

export default client;
